/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FboLocationGroupRequestDto } from '../../models/fbo-location-group-request-dto';
import { FboLocationGroupResponse } from '../../models/fbo-location-group-response';

export interface CreateFboLocationGroup$Params {
      body: FboLocationGroupRequestDto
}

export function createFboLocationGroup(http: HttpClient, rootUrl: string, params: CreateFboLocationGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<FboLocationGroupResponse>> {
  const rb = new RequestBuilder(rootUrl, createFboLocationGroup.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FboLocationGroupResponse>;
    })
  );
}

createFboLocationGroup.PATH = '/api/administration/fbo-locations-groups';
